import "./tabSelectBtns.scss";
import Typography from "../../Typography";

const TabSelectButtonGroup = (props) => {
  const { extraClass, activeTab, tabList, setActiveTab, variant, disabled } =
    props;
  return (
    <div
      className={`tab-select-btn-group${variant ? `--${variant}` : ""} ${
        disabled ? "tab-select-btn-group--disabled" : ""
      } ${extraClass || ""}`}
    >
      {tabList.map((tab, i) => (
        <Typography
          size="text-md"
          weight="medium"
          key={tab.key || i}
          onClick={disabled ? () => {} : () => setActiveTab(tab.key || i)}
          customClass={`tab-btn ${
            activeTab === (tab.key || i) ? "active-tab-btn" : ""
          }`}
        >
          {tab.icon}
          {tab.text}
        </Typography>
      ))}
    </div>
  );
};

export default TabSelectButtonGroup;
